import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'src/app/shared/services';

@Component({
  selector: 'app-add-paint-color-dialog',
  templateUrl: './add-paint-color-dialog.component.html',
  styleUrls: ['./add-paint-color-dialog.component.less']
})
export class AddPaintColorDialogComponent implements OnInit {
  paintColor: any;
  paintApplications: any[] = [];
  paintFinishes: any[] = [];
  selectedApplication: any;
  selectedFinish: any;
  comments: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddPaintColorDialogComponent>,
    private api: ApiService,
    private snackbar:MatSnackBar
  ) { }

  ngOnInit(): void {
    this.paintColor = this.data.paintColor || {};
    this.paintApplications = this.data.paintApplications || [];
    this.paintFinishes = this.data.paintFinishes || [];
    this.selectedApplication = ''
    this.selectedFinish = ''
  }

  getOptionLabel(option: any): string {
    if (!option) {
      return '';
    }
    if (typeof option === 'string') {
      return option;
    }
    return option.name || option.label || option.value || option.application || option.finish || option.title || '';
  }

  submitting = false;
  save(): void {
    this.submitting = true;
    if(!this.selectedApplication || !this.selectedFinish){
      return;
    } else {
      this.submitting = false;
    }
    const data = {
      "room_id": this.api.roomId,
      "paint_color_id": this.paintColor.id,
      "application": this.getOptionLabel(this.selectedApplication),
      "finish": this.getOptionLabel(this.selectedFinish),
      "comments": this.comments
    } 
    this.api.savePaint(data).subscribe((resp:any) => {

      if (resp?.success) {
        this.dialogRef.close({
          id: this.paintColor.id,
          paintColor: this.paintColor,
          application: this.selectedApplication,
          finish: this.selectedFinish,
          comments: this.comments
        });
        this.snackbar.open(resp.message, 'x', {duration:5000})
      } else {
        this.snackbar.open('Error adding paint', 'x', {duration:5000})

      }
    },err=>{
        this.snackbar.open('Error adding paint', 'x', {duration:5000})

    })
  }

  private findDefaultOption(options: any[], defaultLabel: string): any {
    if (!options || !options.length) {
      return null;
    }
    return options.find((option) => this.getOptionLabel(option).toLowerCase() === defaultLabel) || options[0];
  }
}
